// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3lzCt","title":"Info_title__3xDiA","selects":"Info_selects__1j1FO","requiredAsterisk":"Info_requiredAsterisk__bEoZL"};